import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import styled from 'styled-components'
import BackgroundImage from 'gatsby-background-image'

import * as bgcontactStyle from "./bgcontact.module.css"
import { Container, Row, Col } from "react-bootstrap"

const BackgroundSection = ({ className }) => {
  const data = useStaticQuery(
    graphql`
      query {
        desktop: file(relativePath: { eq: "bgcontact.png" }) {
          childImageSharp {
            fluid(quality: 90, maxWidth: 1920) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `
  )

  // Set ImageData.
  const imageData = data.desktop.childImageSharp.fluid

  return (
    <BackgroundImage
      Tag="section"
      className={className}
      fluid={imageData}
      backgroundColor={`#040e18`}
    >
    <Container fluid="xl" className={bgcontactStyle.home}>
        <Row>
          <Col>
            <h3 className={bgcontactStyle.header}>ติดต่อเรา</h3>
            <p className={bgcontactStyle.pstyles}>บริษัท ไทยโพลีแพ็ค จำกัด มีความมุ่งมั่นในการผลิตบรรจุภัณฑ์รูปแบบต่างๆ หลากหลาย เพื่อตอบสนองความต้องการของลูกค้าทั้งในและต่างประเทศ</p>
          </Col>
        </Row>
      </Container>
    </BackgroundImage>
  )
}

const StyledBackgroundSection = styled(BackgroundSection)`
  width: 100%;
  background-position: top left;
  background-repeat: repeat-y;
  background-size: cover;
`

export default StyledBackgroundSection